// eslint-disable-next-line filenames/match-regex
import React from 'react';
import cn from 'classnames';
import type { FC } from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TX5Agreement } from './models';

export const X5BankAgreement: FC<React.PropsWithChildren<TX5Agreement>> = ({
    Checkbox,
    Field,
    Text,
    children,
    dataTestId,
    defaultValue = true,
    getCaption,
    isError,
    isRequired = true,
    name = '',
    size = 'm',
    styles,
    theme = 'white',
    type = 'checkmark',
    useNamedContainers,
    validateAgreement,
}) => {
    const { agreementContent } = useNamedContainers(children);

    return (
        <Field<boolean>
            initialValue={defaultValue}
            name={name}
            render={({ input, meta }) => {
                const asChecked = input.value || false;
                const value = asChecked.toString();

                return (
                    <>
                        <Checkbox
                            checked={input.value}
                            color="green"
                            dataTestId={dataTestId}
                            name={input.name}
                            onChange={({ checked }) => actions.onChange(input, meta)(checked)}
                            size={size}
                            theme={theme}
                            type={type}
                            value={value}
                        >
                            {agreementContent}
                        </Checkbox>
                        {isError(meta) && (
                            <Text
                                className={cn(styles.external, styles.captionError)}
                                kind="caption"
                                view="primary-small"
                            >
                                {getCaption(meta)}
                            </Text>
                        )}
                    </>
                );
            }}
            validate={isRequired ? validateAgreement : undefined}
        />
    );
};
